export const ALL_METRICS = [
  'openInterest',
  'longShort',
  'inflow30d',
  'inflow24h',
  'fundingRate'
];

export const METRIC_OPTIONS = [
  { value: 'openInterest', label: 'Open interest' },
  { value: 'longShort', label: 'Long/Short' },
  { value: 'inflow30d', label: '5d Trading Flow' },
  { value: 'inflow24h', label: 'Trading Flow' },
  { value: 'fundingRate', label: 'Funding rate' },
];